export default __webpack_public_path__ + "ed1a6040bda5423a9a5a84a1823551a6.svg";